// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ls-menu[data-v-77ebff21]{background-color:#000}.ls-menu[data-v-77ebff21]{background-color:#000;border-top:1px solid #1c1f21;z-index:99999}.ls-menu[data-v-77ebff21] .v-ripple__container{display:none}.v-navigation-drawer--is-mobile[data-v-77ebff21]{border-left:none!important;border-right:none!important}.background[data-v-77ebff21]{background-color:#13161a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
